import { Configuration } from "../interface/Configuration";

export const configurationsGT: Configuration = {
    productId: "GT",
    productName: "General Training",
    partRules: [
        {
            noResponse: {
                name: "No Response",
                seconds: 7,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 0,
            },
            repeat: {
                name: "Repeat",
                rules: [
                    {
                        name: "Repeat Stop",
                        type: "PROMPT",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Encourage",
                        type: "ENCOURAGE",
                        maxRepeat: 0,
                    },
                    {
                        name: "Repeat Variant Simplified",
                        type: "VARIANT_SIMPLIFIED",
                        maxRepeat: 0,
                    },
                    {
                        name: "Repeat Variant Backup",
                        type: "VARIANT_BACKUP",
                        maxRepeat: 0,
                    },
                ],
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentThreshold: {
                name: "Intent Threshold",
                seconds: 15,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 7,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 5,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeat: {
                name: "Repeat",
                rules: [
                    {
                        name: "Repeat Stop",
                        type: "PROMPT",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Encourage",
                        type: "ENCOURAGE",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Variant Simplified",
                        type: "VARIANT_SIMPLIFIED",
                        maxRepeat: 0,
                    },
                    {
                        name: "Repeat Variant Backup",
                        type: "VARIANT_BACKUP",
                        maxRepeat: 0,
                    },
                ],
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 7,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeat: {
                name: "Repeat",
                rules: [
                    {
                        name: "Repeat Stop",
                        type: "PROMPT",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Encourage",
                        type: "ENCOURAGE",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Variant Simplified",
                        type: "VARIANT_SIMPLIFIED",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Variant Backup",
                        type: "VARIANT_BACKUP",
                        maxRepeat: 1,
                    },
                ],
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentThreshold: {
                name: "Intent Threshold",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: true,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: true,
            },
        },
    ],
};

const configurationsTrial: Configuration = {
    productId: "Trial",
    productName: "CMS Trial",
    partRules: [
        {
            noResponse: {
                name: "No Response",
                seconds: 5,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 0,
            },
            repeat: {
                name: "Repeat",
                rules: [
                    {
                        name: "Repeat Stop",
                        type: "PROMPT",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Encourage",
                        type: "ENCOURAGE",
                        maxRepeat: 0,
                    },
                    {
                        name: "Repeat Variant Simplified",
                        type: "VARIANT_SIMPLIFIED",
                        maxRepeat: 0,
                    },
                    {
                        name: "Repeat Variant Backup",
                        type: "VARIANT_BACKUP",
                        maxRepeat: 0,
                    },
                ],
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentThreshold: {
                name: "Intent Threshold",
                seconds: 15,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 5,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeat: {
                name: "Repeat",
                rules: [
                    {
                        name: "Repeat Stop",
                        type: "PROMPT",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Encourage",
                        type: "ENCOURAGE",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Variant Simplified",
                        type: "VARIANT_SIMPLIFIED",
                        maxRepeat: 0,
                    },
                    {
                        name: "Repeat Variant Backup",
                        type: "VARIANT_BACKUP",
                        maxRepeat: 0,
                    },
                ],
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 5,
                playVariant: true,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },

            repeat: {
                name: "Repeat",
                rules: [
                    {
                        name: "Repeat Stop",
                        type: "PROMPT",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Encourage",
                        type: "ENCOURAGE",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Variant Simplified",
                        type: "VARIANT_SIMPLIFIED",
                        maxRepeat: 1,
                    },
                    {
                        name: "Repeat Variant Backup",
                        type: "VARIANT_BACKUP",
                        maxRepeat: 1,
                    },
                ],
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentThreshold: {
                name: "Intent Threshold",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: true,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: true,
            },
        },
    ],
};

export const partIndexConfig: Record<string, number> = {
    PART_1: 0,
    PART_2: 1,
    PART_3: 2,
};

// Simulate network delay
export const fetchConfiguration = (product?: string) =>
    new Promise<Configuration>((resolve) => {
        setTimeout(() => {
            resolve(product === "GT" || product === "HOELT" || product === "CRELLA" ? configurationsGT : configurationsTrial);
        }, 1500);
    });
